import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import HeroCustom from '../components/home/Hero';
import ServiceSlide from '../components/home/ServiceSlide';

const BLUE = '#0056b3';
const BLUE_GRADIENT = 'linear-gradient(90deg, #0056b3 60%, #e6f0fa 100%)';
const BLUE_GRADIENT_SOLID = 'linear-gradient(90deg, #0056b3 100%, #0056b3 100%)';

const Home: React.FC = () => {
  const { t } = useTranslation();

  // Service image arrays
  const internationalFreightImages = [
    '/images/Home/service/1.0.jpg',
    '/images/Home/service/1.1.jpg', 
    '/images/Home/service/1.2.jpg',
    '/images/Home/service/1.3.jpg',
    '/images/Home/service/1.4.jpg',
  ];

  const customsClearanceImages = [
    '/images/Home/service/4.0.jpg',
    '/images/Home/service/4.1.jpg', 
    '/images/Home/service/4.2.jpg',
    '/images/Home/service/4.3.jpg',
    '/images/Home/service/4.4.jpg',
  ];

  const heavyCargoImages = [
    '/images/Home/service/2.0.jpg',
    '/images/Home/service/2.1.jpg', 
    '/images/Home/service/2.2.jpg',
    '/images/Home/service/2.3.jpg',
    '/images/Home/service/2.4.jpg',
  ];

  const diplomaticMovingImages = [
    '/images/Home/service/5.0.png',
    '/images/Home/service/5.1.jpg', 
    '/images/Home/service/5.2.jpg',
    '/images/Home/service/5.3.jpg',
    '/images/Home/service/5.4.jpg',
  ];

  return (
    <>
      <HeroCustom />
      {/* About & Blog Section */}
      <section className=" bg-white margin-top-150">
        <Container>
          <Row className='home-about'>
            <Col md={6} className="mb-4 mb-md-0 d-flex align-items-start justify-content-start">
              <img 
                src="/images/Home/about_us.jpg" 
                alt="About R . L Co., Ltd" 
                className="image-hover-animation w-100 rounded"
                style={{ height: '340px', objectFit: 'cover' }}
              />
            </Col>
            <Col md={6}>
              <div className="d-flex align-items-center mb-3">
                <span className="blog-header-bar me-3"></span>
                <h4 className="fw-bold mb-0 text-uppercase header-2 color-brown" style={{ letterSpacing: 1 }}>{t('home.about.title')}</h4>
              </div>
              <p className="body-text text-justify">
                <span className="body-text">{t('home.about.company')}</span><span className="body-text-header color-brown">{t('home.about.header')}</span>
                {t('home.about.description')}
              </p>
              <Link to="/about">
                <Button variant="primary" size="sm" className="text-uppercase fw-bold px-4 about-btn menu-item color-light" style={{ background: BLUE, border: 'none' }}>{t('home.about.learnMore')}</Button>
              </Link>
            </Col>
          </Row>

          {/* Blog & News */}
          <Row className="mt-5">
            <Col md={12}>
              {/* Row containing all four blog items (header + 3 cards) */}
              <Row className="blog-items-row">
                {/* Blog header as the first item/card */}
                <Col xs={12} md={6} lg={3} className="mb-4 d-flex flex-column align-items-start">
                  <div className="d-flex align-items-center mb-2">
                    <span className="blog-header-bar me-3"></span>
                    <h5 className="fw-bold mb-0 text-uppercase header-2 color-brown home-blog-title">{t('home.blog.title')}</h5>
                  </div>
                  <Link to="/news">
                    <Button className="blog-learn-more-btn mb-2 menu-item color-light">{t('home.blog.learnMore')}</Button>
                  </Link>
                </Col>

                {/* Blog Card 1 */}
                <Col xs={12} md={6} lg={3} className="mb-4">
                  <Card className="blog-card hover-animation h-100 border-0">
                    <div className="position-relative">
                      <Card.Img
                        variant="top"
                        src="/images/Home/cla.jpg"
                        className="blog-card-img"
                        style={{ height: '350px', objectFit: 'cover' }}
                      />
                      <div className="blog-gradient-overlay position-absolute top-0 start-0 w-100 h-100"></div>
                      <div className="blog-date-overlay position-absolute top-0 start-0 bg-white p-2 m-2 d-flex flex-column align-items-center">
                        <div className="blog-date-day fw-bold">{t('home.blog.posts.annualParty.date-day')}</div>
                        <div className="blog-date-month">{t('home.blog.posts.annualParty.date-month')}</div>
                      </div>
                      <Card.Body className="blog-card-body position-absolute bottom-0 start-0 w-100 p-2">
                        <h5 className="body-text color-light mb-2">{t('home.blog.posts.claConference.title')}</h5>
                        <Link to="/news/receiving-certificate-from-cla">
                          <Button className="blog-read-more-btn text-uppercase fw-bold menu-item color-secondary">{t('home.blog.readMore')}</Button>
                        </Link>
                      </Card.Body>
                    </div>
                  </Card>
                </Col>

                {/* Blog Card 2 */}
                <Col xs={12} md={6} lg={3} className="mb-4">
                  <Card className="blog-card hover-animation h-100 border-0">
                    <div className="position-relative">
                      <Card.Img
                        variant="top"
                        src="/images/Home/party.jpg"
                        className="blog-card-img"
                        style={{ height: '350px', objectFit: 'cover' }}
                      />
                      <div className="blog-gradient-overlay position-absolute top-0 start-0 w-100 h-100"></div>
                      <div className="blog-date-overlay position-absolute bg-white top-0 start-0 p-2 m-2 d-flex flex-column align-items-center">
                        <div className="blog-date-day fw-bold">{t('home.blog.posts.annualParty.date-day')}</div>
                        <div className="blog-date-month">{t('home.blog.posts.annualParty.date-month')}</div>
                      </div>
                      <Card.Body className="blog-card-body position-absolute bottom-0 start-0 w-100 p-2">
                        <h5 className="body-text color-light mb-2">{t('home.blog.posts.annualParty.title')}</h5>
                        <Link to="/news/annual-party">
                          <Button className="blog-read-more-btn text-uppercase fw-bold menu-item color-secondary">{t('home.blog.readMore')}</Button>
                        </Link>
                      </Card.Body>
                    </div>
                  </Card>
                </Col>

                {/* Blog Card 3 */}
                <Col xs={12} md={6} lg={3} className="mb-4">
                  <Card className="blog-card hover-animation border-0">
                    <div className="position-relative">
                      <Card.Img
                        variant="top"
                        src="/images/Home/meeting.jpg"
                        className="blog-card-img"
                        style={{ height: '350px', objectFit: 'cover' }}
                      />
                      <div className="blog-gradient-overlay position-absolute top-0 start-0 w-100 h-100"></div>
                      <div className="blog-date-overlay position-absolute bg-white top-0 start-0 p-2 m-2 d-flex flex-column align-items-center">
                        <div className="blog-date-day fw-bold">{t('home.blog.posts.annualParty.date-day')}</div>
                        <div className="blog-date-month">{t('home.blog.posts.annualParty.date-month')}</div>
                      </div>
                      <Card.Body className="blog-card-body position-absolute bottom-0 start-0 w-100 p-2">
                        <h5 className="body-text color-light mb-2">{t('home.blog.posts.strategyMeeting.title')}</h5>
                        <Link to="/news/strategy-meeting">
                          <Button className="blog-read-more-btn text-uppercase fw-bold menu-item color-secondary">{t('home.blog.readMore')}</Button>
                        </Link>
                      </Card.Body>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Services Section */}
      <section className="pt-4 bg-white mt-5">
        <Container>
          <div className="service-header d-flex flex-column align-items-start mb-4">
            <div className="d-flex align-items-center mb-2">
              <span className="service-header-bar me-3"></span>
              <h5 className="fw-bold mb-0 text-uppercase header-2 color-brown">{t('home.services.title')}</h5>
            </div>
            <Link to="/services">
              <Button className="service-learn-more-btn mb-2 menu-item color-light">{t('home.services.learnMore')}</Button>
            </Link>
          </div>
          <div className="service-cards-col d-flex flex-column gap-4 w-100">
            <div className="d-flex gap-3">
              <div className="service-bar"></div>
              <Link to="/services#international-freight" className="text-decoration-none flex-fill">
                <div className="service-box">
                  <ServiceSlide 
                    images={internationalFreightImages}
                    alt="International Air Sea Freight"
                    className="image-hover-animation"
                  />
                  <h3 className="color-secondary menu-item">{t('home.services.service1')}</h3>
                </div>
              </Link>
              <div className="service-bar ms-2"></div>
              <Link to="/services#customs-clearance" className="text-decoration-none flex-fill">
                <div className="service-box">
                  <ServiceSlide 
                    images={customsClearanceImages}
                    alt="Customs Clearance"
                    className="image-hover-animation"
                  />
                  <h3 className="color-secondary menu-item">{t('home.services.service2')}</h3>
                </div>
              </Link>
            </div>
            <div className="d-flex gap-3">
              <div className="service-bar"></div>
              <Link to="/services#heavy-cargo" className="text-decoration-none flex-fill">
                <div className="service-box">
                  <ServiceSlide 
                    images={heavyCargoImages}
                    alt="Heavy and Project Cargo"
                    className="image-hover-animation"
                  />
                  <h3 className="color-secondary menu-item">{t('home.services.service3')}</h3>
                </div>
              </Link>
              <div className="service-bar ms-2"></div>
              <Link to="/services#packaging" className="text-decoration-none flex-fill">
                <div className="service-box">
                  <ServiceSlide 
                    images={diplomaticMovingImages}
                    alt="Diplomatic Moving"
                    className="image-hover-animation"
                  />
                  <h3 className="color-secondary menu-item">{t('home.services.service4')}</h3>
                </div>
              </Link>
            </div>
          </div>
        </Container>
      </section>

      {/* Careers Section */}
      <section className="pt-5 careers-section position-relative" style={{ background: 'none' }}>
        <Container fluid className="p-0 position-relative">
          <div
            className="careers-image-with-gradient w-100"
            style={{
              height: '340px',
              background: `linear-gradient(90deg, #a4b9d1bd 60%, #e6f0fa6d 100%), url('/images/Home/careers.jpg') center center / cover no-repeat`
            }}
          />
          <div className="careers-content-left position-absolute top-50 start-50 translate-middle text-white p-4 text-center" style={{ zIndex: 2 }}>
            <h5 className="fw-bold text-uppercas mb-4 header-2 color-brown">{t('home.careers.title')}</h5>
            <div className="text-black fw-bold menu-item color-dark">{t('home.careers.description-1')}</div>
            <div className="mb-3 text-black fw-bold menu-item color-dark">{t('home.careers.description-2')}</div>
            <Link to="/career">
              <Button variant="primary" size="sm" className="text-uppercase fw-bold px-4 careers-btn menu-item color-brown">{t('home.careers.learnMore')}</Button>
            </Link>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Home; 